import { Drawer, DrawerProps } from '@mui/material';
import React, { FC } from 'react';

const DrawerWrapper: FC<DrawerProps> = ({ ...props }) => <Drawer {...props}/>

export default DrawerWrapper;
